import client from './client';
import _filterLatest from './utils/filterLatest';
import _filterFields from './utils/filterFields';

function Get() {
  this.$data = null;
}

/**
 * Get an entry by ID
 */
Get.prototype.entry = async function entry() {
  this.$data = await client.getEntry(this.id);
  return this;
};

/**
 * Get an entries by contentType
 */
Get.prototype.entries = async function entries() {
  this.$data = await client.getEntries({ content_type: this.contentType });
  return this;
};

/**
 * Utility Functions
 */
Get.prototype.filterLatest = function filterLatest() {
  this.$data = _filterLatest(this.$data);
  return this;
};

Get.prototype.filterFields = function filterFields() {
  this.$data = _filterFields(this.$data);
  return this;
};

Get.prototype.data = function data() {
  const { $data } = this;
  this.$data = null;
  return $data;
};

export default Get;
